<template lang="pug">
  section.section-1
    svg.red-line
      use(xlink:href="#red-line--sprite")
    .section-1__block(v-if="lang==='ru'")
      .section-1__text
        p(v-for="(item, index) in text1", :key="index") {{ item }}
    .section-1__block(v-if="lang==='en'")
      .section-1__text
        p(v-for="(item, index) in text2", :key="index") {{ item }}
</template>

<script lang="js">
  export default {
    name: 'section-1',
    props: {
      lang: String
    },
    data() {
      return {
        text1: [ 'Перевозки', 'контейнеров', 'в составе', 'ускоренных', 'поездов' ],
        text2: [ 'Railway', 'transportation', 'of containers', 'in', 'block trains' ]
      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
  @import "../../style/variables";
  $s: 15vw;

  .section-1 {
    position: relative;
    margin-top: 100px;
    display: flex;
    align-items: center;
    height: 47vw;
    background-image: url('~@/assets/train.png');
    background-repeat: no-repeat;
    background-position: right;
    background-size: 75vw;
    overflow: hidden;

    &::after {
      content: '';
      display: flex;
      position: absolute;
      bottom: -1px;
      right: -1px;
      width: 21vw;
      height: 21vw;
      background-image: url('~@/assets/svg/triangle.svg');
      background-repeat: no-repeat;
      background-position: bottom right;
      background-size: contain;
    }

    .red-line {
      top: ($s / 2);
      right: -($s / 2.2);
      width: $s;
      height: $s;
      position: absolute;
    }

    &__block {
      position: absolute;
      right: 56vw;
      padding: 38px;
      width: 35vw;
      height: 32vw;
      background-color: $red-color;
      box-shadow: $shadow;
      z-index: 2;
    }
    &__text {
      line-height: 1;
      text-align: left;
      font-weight: 500;
      font-size: 3vw;
      color: #fff;
    }
  }
</style>
